import jsonp from "jsonp";

export default () => ({
    open: false,
    isMobile: false,
    firstName: "",
    lastName: "",
    emailString: "",
    location: "",
    formSuccess: false,
    formError: false,
    formMessage: "",
    loading: false,
    formData: {
        EMAIL: "",
        FNAME: "",
        LNAME: "",
        ADDRESS: "",
    },

    currentLang: window.lang || "en",

    init() {},

    destroy() {},

    sendData() {
        this.loading = true;
        jsonp(
            `https://dezentrum.us17.list-manage.com/subscribe/post-json?u=7f5ec7a3276754731c4026229&id=1fd73e0aaa&f_id=00776ee0f0&EMAIL=${
                this.emailString
            }&FNAME=${this.firstName}&LNAME=${this.lastName}&tags=11262300${
                this.location.length
                    ? "&ADDRESS[city]=" +
                      this.location +
                      "&ADDRESS[addr1]=-&ADDRESS[state]=-&ADDRESS[zip]=-&ADDRESS[country]=CH"
                    : ""
            }`,
            { param: "c", name: "jsonpFunc" },
            (err, data) => {
                if (data.result === "success") {
                    (this.formSuccess = true), (this.formError = false);
                    this.formMessage = data.msg;
                } else if (data.result === "error") {
                    this.formSuccess = false;
                    this.formError = true;
                    this.formMessage = data.msg;
                    console.log(data);
                } else {
                    (this.formSuccess = false), (this.formError = true);
                    this.formMessage = data.msg;
                    console.log(data);
                }
            },
        );
    },
});
